import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
            <div className="footer-container">
                {/* Logo Section */}
                <div className="footer-logo">
                    <img src={require("../../assets/images/logo.svg")} alt="Österreichische Nationalbibliothek Logo" />
                </div>

                {/* Links Section */}
                <div className="footer-links">
                    <ul style={{ marginRight: "50px" }}>
                        <li><a href="https://www.onb.ac.at/kontakt">Kontakt</a></li>
                        <li><a href="https://www.onb.ac.at/presse">Presse</a></li>
                        <li><a href="https://www.onb.ac.at/mehr/karriere">Karriere</a></li>
                        <li>
                            <a href="https://search.onb.ac.at/primo-explore/search?vid=ONB">
                                Katalog <i className="fa-solid fa-arrow-right" style={{ transform: "rotate(-45deg)" }}></i>
                            </a>
                        </li>
                    </ul>
                    <ul style={{ marginRight: "30px" }}>
                        <li><a href="https://www.onb.ac.at/kalender">Kalender</a></li>
                        <li><a href="https://www.onb.ac.at/newsletter">Newsletter</a></li>
                        <li><a href="https://www.onb.ac.at/faq">FAQ</a></li>
                        <li><a href="https://www.onb.ac.at/mehr/raumvermietungen">Raumvermietung</a></li>
                    </ul>
                    <ul>
                        <li>
                            <a href="https://www.onb.ac.at/mehr/foerdern/helfen-sie-uns-kunstschaetze-zu-bewahren">
                                Fördern und unterstützen
                            </a>
                        </li>
                        <li>
                            <a href="https://www.onb.ac.at/mehr/gesellschaft-der-freunde-der-oesterreichischen-nationalbibliothek">
                                Gesellschaft der Freunde
                            </a>
                        </li>
                        <li><a href="https://www.onb.ac.at/feedback">Feedback</a></li>
                    </ul>
                </div>

                {/* Contact Section */}
                <div className="footer-contact">
                    <p><strong>Österreichische Nationalbibliothek</strong></p>
                    <p>Josefsplatz 1, 1015 Wien</p>
                    <p>Postfach 25</p>
                    <p>Tel: +43 1 534 10</p>
                    <p>Fax: +43 1 534 10-280</p>
                    <p>Signal-Messenger: +43 664 964 4181</p>
                </div>

                {/* Social Media Section */}
                <div className="footer-social-wrapper">
                    <div className="footer-social">
                        <a href="https://www.facebook.com/nationalbibliothek/">
                            <img src={require("../../assets/images/facebook.svg")} alt="Facebook" />
                        </a>
                        <a href="https://www.instagram.com/nationalbibliothek/">
                            <img src={require("../../assets/images/instagram.svg")} alt="Instagram" />
                        </a>
                        <a href="https://www.youtube.com/channel/UCO3YP1wh1B5CCPQy0ievSUA">
                            <img src={require("../../assets/images/youtube.svg")} alt="YouTube" />
                        </a>
                    </div>
                    <img
                        src={require("../../assets/images/nachhaltigkeit.png")}
                        alt="Umweltzeichenbild"
                        style={{ width: "100px", height: "auto", marginTop: "10px" }}
                    />
                </div>
            </div>
    );
};

export default Footer;
